import { useCallback } from 'react';
import { Board } from '@/components/organisms';
import { Wrapper } from './CollectBoard.styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, SwiperOptions } from 'swiper';
import { IBoardItem, IBoardProps } from '@/types';
import { IntersectionObserver } from '@/components/common';
import { clickEventHandler } from '@/helpers';
import { COMPONENT_TYPE, EVENT_TYPE } from '@/const';
import { useCommonParams, useDeviceId, useLoading } from '@/hooks';

SwiperCore.use([Pagination, Autoplay]);

const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return `<span class=${className}></span>`;
  },
};

const CollectBoard = (props: IBoardProps) => {
  const { ads = [] } = props;
  const commonParams = useCommonParams();
  const [deviceId] = useDeviceId();
  const [, setLoading] = useLoading();

  const swiperSettings: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: ads ? ads.length > 1 : false,
    autoplay: ads.length > 1 ? { delay: 5000, disableOnInteraction: false } : false,
    pagination: ads.length > 1 ? pagination : false,
  };

  const handleClick = useCallback(
    async (item: IBoardItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        type: EVENT_TYPE.CLICK.DEFAULT,
        deviceId,
        setLoading,
        componentName: COMPONENT_TYPE.BOARD,
      });
    },
    [commonParams, deviceId, setLoading],
  );

  return (
    <Wrapper>
      <Swiper {...swiperSettings}>
        {ads.map((item: IBoardItem, index: number) => (
          <SwiperSlide key={`collect-board-${index}`}>
            <IntersectionObserver {...item} page={commonParams.page} componentName={COMPONENT_TYPE.BOARD}>
              <Board
                {...item}
                onClickButton={() => handleClick(item)}
                onClickBoard={() => handleClick(item)}
              />
            </IntersectionObserver>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  );
};

export default CollectBoard;
